import { apiErrorCode } from './apiErrorCode';
import { transferErrorText } from './contentTransfer';

/**
 * Плоский список уроков курса в админке (решение владельца 01.10.2026: модулей в
 * продукте нет, админ видит один список). Договор — `docs/CONTRACTS/constructor-v2.md` §2.8.
 *
 * Здесь то, что проверяется без экрана: куда класть новый урок, когда стрелке
 * некуда идти и как назвать отказ шага.
 */

type ModuleLike = { id: string; lessons?: unknown[] | null };
type T = (key: string, vars?: Record<string, unknown>) => string;

/**
 * Модуль для нового урока — тот, где стоит последний урок списка.
 *
 * Раньше брался первый модуль курса: в курсе с несколькими модулями новый урок
 * вставал в середину списка, а не снизу. Пустые модули в хвосте пропускаем по
 * той же причине: список их не показывает, но урок из такого модуля оказался бы
 * ниже всех только до тех пор, пока в модуль перед ним ничего не добавили.
 * Уроков нет вовсе — последний модуль; модулей нет — `undefined` (страница заведёт модуль).
 */
export function newLessonModuleId(modules: ModuleLike[] | null | undefined): string | undefined {
  const list = modules ?? [];
  for (let i = list.length - 1; i >= 0; i -= 1) {
    if ((list[i].lessons ?? []).length > 0) return list[i].id;
  }
  return list[list.length - 1]?.id;
}

/**
 * Есть ли куда шагнуть. Граница модуля стрелку не выключает — шаг ходит по всему
 * списку; выключены только «Выше» у первого урока и «Ниже» у последнего.
 */
export function canStepLesson(index: number, total: number, dir: -1 | 1): boolean {
  const next = index + dir;
  return index >= 0 && next >= 0 && next < total;
}

/**
 * Отказ шага. В курсе потока урок не переходит границу модуля (409): зеркало
 * строки между модулями не переносит. Различать по `code` — `humanizeError` на
 * любой 409 сказал бы «такая запись уже существует».
 */
export function stepErrorText(err: unknown, t: T): string {
  if (apiErrorCode(err) === 'step_across_modules_in_subtype') {
    return t('adminMarathonDetail.errStepAcrossModules');
  }
  return transferErrorText(err, t);
}
